import React, { Fragment }  from 'react';
import { NavLink } from 'redux-first-router-link';
import PropTypes from 'prop-types';
import OutboundLink from '../../../common/OutboundLink';
import ProductReviewProcess from '../../ProductReviewProcess';
import { SLUGS_MAP } from '../../../../consts';
import { getFileName, isValid, isText, decodeTags, segmentTrackEvent } from '../../../../utils';
import { PinterestShareButton } from 'react-share';

const SlideshowLander = ({
  headline,
  data,
  category,
  isMobile,
  fullUrl=null,
  pubData,
  name,
  authorImg,
  link,
  sponsorship,
  display,
  tags,
  secondAuthorName,
  secondAuthorText,
  secondAuthorUrl,
  isAffiliate,
  isSponsored,
  handleLinkClick,
  setSlideNumber,
  slideNumber,
  handleRelatedStory,
  seo,
}) => {
  if (!isValid(data)) { return null; }
  const {
    imageSrcDesktop,
    imageSrcMobile,
    credit,
    usePinterest = isMobile,
    imagePinterestOverride,
    imageAlt,
  } = data;
  const {
    sponsorshipUrl,
    sponsorshipBannerOverride,
    sponsorshipImage,
  } = sponsorship;
  const {
    date = null,
    first = null,
  } = pubData;

  const imageSrc = (isMobile && isValid(imageSrcMobile)) ? imageSrcMobile : isValid(imageSrcDesktop) ? imageSrcDesktop : null;
  const imgAlt = isText(imageAlt) ? imageAlt : getFileName(imageSrc);
  const pinMedia = isValid(imagePinterestOverride) ? imagePinterestOverride : imageSrc;
  const showPin = Boolean(fullUrl && pinMedia);
  const text = decodeTags(data.text);

  const renderDate = (date) => {
    if (!isValid(date)) {
      return null;
    }
    let options = {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    };
    const renderedDate = new Date(date.replace(/\s/, 'T')).toLocaleString('en-us', options)
    return renderedDate;
  };

  const pubDate = first ? new Date(first.replace(/\s/, 'T')) : date ? new Date(date.replace(/\s/, 'T')) : null;
  const upDate = date ? new Date(date.replace(/\s/, 'T')) : null;
  const renderedPubDate = first ? renderDate(first) : date ? renderDate(date) : null;
  const renderedUpDate = date ? renderDate(date) : null;

  let renderedPubTime = pubDate ? pubDate.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }) : null;
  // remove the leading 0 if hour is less than 10, make am/pm lowercase, removes whitespace between time -> am/pm
  renderedPubTime = renderedPubTime ? renderedPubTime
    .toLowerCase()
    .replace(/^0(?:0:0?)?/, '')
    .replace(/\s/, '') : null;

  let renderedUpTime = upDate ? upDate.toLocaleTimeString(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  }) : null;
  // remove the leading 0 if hour is less than 10, make am/pm lowercase, removes whitespace between time -> am/pm

  renderedUpTime = renderedUpTime ? renderedUpTime
    .toLowerCase()
    .replace(/^0(?:0:0?)?/, '')
    .replace(/\s/, '') : null;

  const dateLine = (upDate && (upDate > pubDate)) ? `Updated ${renderedUpDate}` : `Published ${renderedPubDate}`;
  const timeLine = (upDate && (upDate > pubDate)) ? `${renderedUpTime}` : `${renderedPubTime}`;

  const authorImgAlt = `${name} image`;
  const showTime = (isValid(display.time) && display.time === '1');
  const showDate = (isValid(display.date) && display.date === '1');
  const sponsText = isValid(sponsorshipBannerOverride) ? sponsorshipBannerOverride : isText(sponsorshipImage) ? "Sponsored By" : "Sponsored";
  const showAuthor = (isValid(display.author) && display.author === '1');
  const showSlugs = (isValid(display.taggedSlugs) && display.taggedSlugs === '1');
  const secondAuthorLink = `/author/${secondAuthorUrl}`;
  let slug = null;
  if (isValid(tags)) {
    const slugTags = tags.filter(tag => (SLUGS_MAP[tag]));
    if (slugTags.length > 0 && showSlugs) {
      const slugTag = slugTags[0];
      slug = SLUGS_MAP[slugTag];
    }
  }
  const renderedTaggedSlug = (
    <Fragment>
    { slug &&
      <Fragment>
        <div className={'slide-slug ' + slug.className}>
          <NavLink to={slug.url} target="_blank">{slug.text}</NavLink>
        </div>
        <div className="cat-divider"></div>
      </Fragment>
    }
    </Fragment>
  );

  let relatedLinkBodyText;
  let bodyTextAfterRelatedLink;
  let justBodyText;
  let slideLanderText;
  const relatedTag = '<p class="related-story-link">';
  const hasRelatedStoryLink = text.includes(relatedTag);
  if (isText(text) && hasRelatedStoryLink) {
    const relatedStoryData = handleRelatedStory(text);
    relatedLinkBodyText = relatedStoryData.relatedLinkBodyText || null;
    bodyTextAfterRelatedLink = relatedStoryData.bodyTextAfterRelatedLink || null;
    justBodyText = relatedStoryData.justBodyText || null;
  }

  {hasRelatedStoryLink ? (
    slideLanderText = 
    <Fragment>
      <div className="slide-lander-text" dangerouslySetInnerHTML={ { __html: justBodyText } }  onClick={e => handleLinkClick(e)}/>
      <div className="related-story-link-container">
        <div className="related-header">
          <strong>RELATED</strong>
          <hr></hr>
        </div>
        <div className='body-text' dangerouslySetInnerHTML={ { __html: relatedLinkBodyText } } onClick={e => handleLinkClick(e)} />
        <hr></hr>
      </div>
      {(isValid(bodyTextAfterRelatedLink))
        && <div className='slide-lander-text' dangerouslySetInnerHTML={ { __html: bodyTextAfterRelatedLink } } />
      }
    </Fragment>
  ) : (
    slideLanderText = 
    <Fragment>
      <div className="slide-lander-text" dangerouslySetInnerHTML={ { __html: text } }  onClick={e => handleLinkClick(e)}/>
    </Fragment>
  )}
  
  return (
    <div className={`slide-lander ${(!isMobile && slideNumber !== 0) ? 'hidden' : ''}`}>
      <div className="slide-lander-img-wrapper">
        <img className="slide-lander-img" src={imageSrc} alt={imgAlt} />
        { !isMobile && <div className="slide-lander-img-overlay"/> }
        {credit &&
          <div className="slide-lander-img-credit" dangerouslySetInnerHTML={ { __html: credit } }></div>
        }
        { usePinterest && showPin && 
          <div className="social-pin-wrapper">
            <PinterestShareButton
                className="social-share-unit pinterest"
                onClick={() => segmentTrackEvent('pinterest_share', {action: 'social', label: 'pin_share'})}
                url={fullUrl}
                alt={imgAlt || 'pinterest share image'}
                description={seo.metaDescription}
                media={pinMedia || 'https://www.purewow.com/static-gmg/purewow/logos/purewow-mark-salmon.jpg'}>
            </PinterestShareButton>
          </div> }
        { !isMobile &&
          <div className="slide-lander-hed-container">
            <span className="slide-category">{category}</span>
            <div className="slide-divider"/>
            <h1 className="slide-hed">{headline}</h1>
            <div className="btn-start-slideshow button-text" onClick={e => { setSlideNumber(1) }}>Start Slideshow</div>
          </div>
        }
      </div>
      { isMobile ? (
        slideLanderText
      ) : (
        <div className="slide-lander-text-container">
          <div className="slide-lander-text-inner-wrapper">
            <div className="slide-lander-category-wrapper">
              {renderedTaggedSlug}
               <NavLink
                className={`slide-lander-category ${category}`}
                to={ { type: 'LANDER', payload: { category } } }>
                  {category}
              </NavLink>
            </div>
            { isSponsored ? (
              <Fragment>
                <div className="slide-lander-byline sponsored">
                { showAuthor &&
                    <Fragment>
                      <img className="slide-author-img" src={authorImg} alt={authorImgAlt} />
                      <span className="slide-lander-author">By <NavLink to={link} target="_blank">{name}</NavLink></span>
                    </Fragment>
                  }
                  { (showDate && showAuthor) && <span className="slide-lander-dot"/> }
                  { showDate && 
                    <Fragment>
                      <span className="slide-lander-date">{dateLine}</span> 
                      <span className="slide-lander-dot"/>
                    </Fragment>
                  }
                  { showTime && 
                    <Fragment>
                      <span className="slide-lander-time">{timeLine}</span> 
                      <span className="slide-lander-dot"/>
                    </Fragment>
                  }
                  <span className="spons-text">{sponsText}</span> 
                  { isText(sponsorshipImage) &&
                    <OutboundLink href={sponsorshipUrl} className="spons-link">
                      <img className="spons-img" src={sponsorshipImage} />
                    </OutboundLink>
                  }
                </div>
              </Fragment>
            ): (
              <Fragment>
                <div className="slide-lander-byline">
                  { showAuthor &&
                    <Fragment>
                      <img className="slide-author-img" src={authorImg} alt={authorImgAlt} />
                      <span className="slide-lander-author">By <NavLink to={link} target="_blank">{name}</NavLink></span>
                    </Fragment>
                  }
                  { (showDate && showAuthor) && <span className="slide-lander-dot"/> }
                  { showDate && <span className="slide-lander-date">{dateLine}</span> }
                  { (showDate && showTime || showAuthor && showTime) && <span className="slide-lander-dot"/>  }
                  { showTime && <span className="slide-lander-time">{timeLine}</span> }
                </div>
                { (secondAuthorName && showAuthor) &&
                  <span className="slide-second-author-container">{secondAuthorText} <OutboundLink href={secondAuthorLink} className="slide-second-author">{secondAuthorName}</OutboundLink></span>
                }
              </Fragment>
            )}
            <div className="slide-lander-divider"/>  
            { isAffiliate && 
              <ProductReviewProcess
                isMobile={isMobile}
              />
            }
            {slideLanderText}
          </div>
        </div>
      )}
    </div>
  );
};

SlideshowLander.propTypes = {
  lideshowLander: PropTypes.object,
  isMobile: PropTypes.bool,
};

export default SlideshowLander;
